/* @flow */

import isEqual from 'lodash/isEqual';
import Immutable from 'immutable';

/**
 * Immutable.js aware deep equals method
 *
 * @param {*} a any value
 * @param {*} b any other value
 * @returns {boolean} true if the values are equal
 */
function equal(a: any, b: any): boolean {
  if (a === b) return true;
  if (a instanceof Immutable.Iterable && b instanceof Immutable.Iterable) {
    return Immutable.is(a, b);
  } else {
    if (a instanceof Immutable.Iterable) {
      a = a.toJS();
    }
    if (b instanceof Immutable.Iterable) {
      b = b.toJS();
    }
    return isEqual(a, b);
  }
}

export { equal };
